import { render, staticRenderFns } from "./PageStatus.vue?vue&type=template&id=2938d6b1&scoped=true"
import script from "./PageStatus.vue?vue&type=script&lang=js"
export * from "./PageStatus.vue?vue&type=script&lang=js"
import style0 from "./PageStatus.vue?vue&type=style&index=0&id=2938d6b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938d6b1",
  null
  
)

export default component.exports